import usePending from '@anm//hooks/usePending';
import UserLimits from '@anm/components/user/UserLimits';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from '../../../store/modules/user';

import { useFetchAllStats, useLimitsData } from './hooks';

export * from './hooks';

const UserLimitsWrapper: FC = () => {
  useFetchAllStats();
  const { isPending: isLimitsPending, ...limitsProps } = useLimitsData();
  const subscription = useSelector(userSelectors.selectWaveSubscription);
  const isMaxPlan = useSelector(userSelectors.selectIsMaxWavePlan);
  const isPending = usePending(isLimitsPending);

  return (
    <UserLimits isPending={isPending} {...limitsProps} planName={subscription?.displayName} canUpgrade={!isMaxPlan} />
  );
};

export default UserLimitsWrapper;
